import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { AuthService } from './auth.service';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    constructor(private readonly location: Location, private readonly router: Router, private authService: AuthService) { }

    canDeactivate(component: CanComponentDeactivate, currentRoute: ActivatedRouteSnapshot) {
        if (!this.authService.isLoggedIn()) {
            return true;
        }
        const currentUrlTree = this.router.createUrlTree([], currentRoute);
        const currentUrl = currentUrlTree.toString();
        this.location.go(currentUrl);
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}
